export const SCREEN_LABELS: Record<string, string> = {
  SenderRequestDashboard: 'Sender Request Dashboard',
  MonitorDashboard: 'Monitor Dashboard',
  SenderComplaintList: 'Sender Complaint List',
  UserManagement: 'User Management',
  ScamMonitoringList: 'Scam Monitoring List',
  AttachmentCategory: 'Attachment Category',
  Keywords: 'Keywords',
  Regulations: 'AI regulations',
  SenderConnectivity: 'Sender Connectivity',
  SuggestionsAndSystemEnhancement: 'Suggestions & System Enhancement',
  RatingResult: 'Rating Result',
  OverviewReport: 'Overview Report',
  ConnectivityActivationReport: 'Connectivity Activation Report',
  ContractRequestDashboard: 'Contract Requests Dashboard',
  PreApprovedTemplates: 'Pre-Approved Templates',
};

export const KEY_TO_SCREEN: Record<string, string> = {
  SenderRequestDashboard: 'SenderRequestDashboard',
  MonitorDashboard: 'MonitorDashboard',
  SenderComplaints: 'SenderComplaintList',
  UserManagement: 'UserManagement',
  Scams: 'ScamMonitoringList',
  AttachmentCategory: 'AttachmentCategory',
  CITCKeywords: 'Keywords',
  RegulationsManagement: 'Regulations',
  SenderConnectivity: 'SenderConnectivity',
  SuggestionsAndSystemEnhancement: 'SuggestionsAndSystemEnhancement',
  RatingResults: 'RatingResult',
  ReportsOverview: 'OverviewReport',
  ConnectivityActivationReport: 'ConnectivityActivationReport',
  ContractRequestDashboard: 'ContractRequestDashboard',
  PreApprovedTemplates: 'PreApprovedTemplates',
};
